import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

function ytEmbed(url) {
    if (!url) return null;
    const m = url.match(/(?:youtu\.be\/|v=|embed\/)([\w-]{11})/);
    return m ? `https://www.youtube.com/embed/${m[1]}?autoplay=1` : null;
}

export function hasVideo(m) {
    return !!(m && (m.video_url || m.video_vertical_url));
}

export function bestVideo(m) {
    if (!m) return null;
    if (m.video_url) {
        const yt = ytEmbed(m.video_url);
        return yt ? { kind: "yt", url: yt, vertical: false } : { kind: "file", url: resolveUrl(m.video_url), vertical: false };
    }
    if (m.video_vertical_url) return { kind: "file", url: resolveUrl(m.video_vertical_url), vertical: true };
    return null;
}

export const VideoModal = ({ open, onClose, mentor }) => {
    const v = open ? bestVideo(mentor) : null;
    return (
        <AnimatePresence>
            {open && v && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                    data-testid="video-modal"
                    className="fixed inset-0 z-[110] flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm"
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.35 }}
                        onClick={(e) => e.stopPropagation()}
                        className={`relative w-full ${v.vertical ? "max-w-[380px]" : "max-w-3xl"}`}
                    >
                        <div className="mb-3 flex items-center justify-between">
                            <p className="text-sm font-semibold uppercase tracking-widest text-primary">
                                Testimonio · {mentor.display_name}
                            </p>
                            <button onClick={onClose} data-testid="video-modal-close" className="rounded-full bg-white/10 p-2 text-white transition-all hover:bg-white/20">
                                <X size={18} />
                            </button>
                        </div>
                        {v.kind === "yt" ? (
                            <div className="aspect-video overflow-hidden rounded-2xl">
                                <iframe src={v.url} title="testimonio" className="h-full w-full" allow="autoplay; fullscreen" allowFullScreen />
                            </div>
                        ) : (
                            <video
                                src={v.url}
                                controls
                                autoPlay
                                playsInline
                                className={`w-full rounded-2xl bg-black ${v.vertical ? "aspect-[9/16] max-h-[80vh]" : "aspect-video"}`}
                            />
                        )}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
